import ApplicationLoader from "@/ApplicationLoader";

import MeterContainer from "./MeterContainer";

const AppLoader = new ApplicationLoader(MeterContainer);

AppLoader.start();
